export const PER_PAGE_OPTIONS = [10, 20, 30, 50] as const;

export const PER_PAGE_DEFAULT = 10;
